import { LocalStorageKeys } from '@/types';
export var DeepLinkQueryKey = 'deep_link';
export var DeepLinkQueryValue = '1';
export var PendingDeepLinkStorageKey = 'pendingDeepLink';
export var PendingDeepLinkTtl = 30 * 60 * 1000;
var AppsFlyerDeepLinkValueKey = 'deep_link_value';
var AppsFlyerDeepLinkSub1Key = 'deep_link_sub1';
var AppsFlyerWebFallbackKey = 'af_web_dp';
var ProjectDeepLinkValue = '/project/detail';
var DeepLinkBaseUrl = 'https://careecon-deep-link.local';
export var getSessionStorage = function () {
    if (typeof window === 'undefined') {
        return null;
    }
    try {
        return window.sessionStorage;
    }
    catch (e) {
        return null;
    }
};
export var isInternalUrl = function (url) {
    if (!url.startsWith('/') ||
        url.startsWith('//') ||
        url.includes('\\') ||
        Array.from(url).some(function (char) { return char.charCodeAt(0) <= 32; })) {
        return false;
    }
    try {
        return new URL(url, DeepLinkBaseUrl).origin === DeepLinkBaseUrl;
    }
    catch (e) {
        return false;
    }
};
var isIdentifier = function (value) {
    return !!value && /^\d+$/.test(value);
};
var getQueryString = function (query, key) {
    var value = query[key];
    return typeof value === 'string' ? value : null;
};
var getQueryFromUrl = function (url) {
    var query = {};
    url.searchParams.forEach(function (value, key) {
        query[key] = value;
    });
    return query;
};
var decodeDeepLinkValue = function (value) {
    var decoded = value;
    for (var index = 0; index < 2; index += 1) {
        try {
            var next = decodeURIComponent(decoded);
            if (next === decoded) {
                return decoded;
            }
            decoded = next;
        }
        catch (e) {
            return decoded;
        }
    }
    return decoded;
};
// JSON.parseは19桁の案件IDをNumberへ変換して精度を失うため、IDは文字列として抽出する
var getJsonValue = function (json, key) {
    var pattern = new RegExp("\"" + key + "\"\\s*:\\s*(?:\"([^\"]+)\"|([0-9]+))");
    var match = pattern.exec(json);
    return match ? match[1] || match[2] || null : null;
};
var getNestedJsonValue = function (json, objectKey, key) {
    var objectPattern = new RegExp("\"" + objectKey + "\"\\s*:\\s*\\{([^{}]*)\\}");
    var objectMatch = objectPattern.exec(json);
    return objectMatch ? getJsonValue(objectMatch[1], key) : null;
};
var parseProjectUrl = function (value) {
    try {
        var url = new URL(value, DeepLinkBaseUrl);
        if (url.pathname.startsWith('/companies/')) {
            return url;
        }
        return new URL(decodeDeepLinkValue(value), DeepLinkBaseUrl);
    }
    catch (e) {
        return null;
    }
};
var getProjectPath = function (value) {
    if (!value) {
        return null;
    }
    try {
        var url = parseProjectUrl(value);
        if (!url) {
            return null;
        }
        var match = /^\/companies\/([^/]+)\/projects\/([^/]+)$/.exec(url.pathname);
        if (!match) {
            return null;
        }
        var companyId = decodeDeepLinkValue(match[1]);
        var projectId = decodeDeepLinkValue(match[2]);
        if (!isIdentifier(companyId) || !isIdentifier(projectId)) {
            return null;
        }
        if (url.searchParams.get(DeepLinkQueryKey) !== DeepLinkQueryValue) {
            url.searchParams.set(DeepLinkQueryKey, DeepLinkQueryValue);
        }
        var search = url.searchParams.toString();
        return {
            companyId: companyId,
            projectId: projectId,
            targetUrl: "" + url.pathname + (search ? "?" + search : '') + url.hash
        };
    }
    catch (e) {
        return null;
    }
};
var getAppsFlyerProjectDeepLink = function (query) {
    var deepLinkValue = getQueryString(query, AppsFlyerDeepLinkValueKey);
    if (!deepLinkValue || decodeDeepLinkValue(deepLinkValue) !== ProjectDeepLinkValue) {
        return null;
    }
    var deepLinkSub1 = getQueryString(query, AppsFlyerDeepLinkSub1Key);
    var decodedParams = deepLinkSub1 ? decodeDeepLinkValue(deepLinkSub1) : null;
    var fallback = getProjectPath(getQueryString(query, AppsFlyerWebFallbackKey));
    var projectId = decodedParams
        ? getNestedJsonValue(decodedParams, 'project', 'id') ||
            getJsonValue(decodedParams, 'project_id')
        : null;
    var companyId = decodedParams
        ? getJsonValue(decodedParams, 'company_id') ||
            getNestedJsonValue(decodedParams, 'company', 'id') ||
            getNestedJsonValue(decodedParams, 'project', 'company_id')
        : null;
    var resolvedProjectId = projectId || (!companyId || companyId === (fallback === null || fallback === void 0 ? void 0 : fallback.companyId) ? fallback === null || fallback === void 0 ? void 0 : fallback.projectId : null);
    var resolvedCompanyId = companyId || (!projectId || projectId === (fallback === null || fallback === void 0 ? void 0 : fallback.projectId) ? fallback === null || fallback === void 0 ? void 0 : fallback.companyId : null);
    if (!isIdentifier(resolvedProjectId) || (resolvedCompanyId && !isIdentifier(resolvedCompanyId))) {
        return null;
    }
    return {
        projectId: resolvedProjectId,
        companyId: resolvedCompanyId || null,
        targetUrl: (fallback === null || fallback === void 0 ? void 0 : fallback.projectId) === resolvedProjectId && (fallback === null || fallback === void 0 ? void 0 : fallback.companyId) === resolvedCompanyId
            ? fallback.targetUrl
            : null
    };
};
export var isDeepLinkQuery = function (query) {
    return (getQueryString(query, DeepLinkQueryKey) === DeepLinkQueryValue ||
        !!getAppsFlyerProjectDeepLink(query));
};
export var isDeepLinkUrl = function (url) {
    if (!isInternalUrl(url)) {
        return false;
    }
    try {
        var parsedUrl = new URL(url, DeepLinkBaseUrl);
        return isDeepLinkQuery(getQueryFromUrl(parsedUrl));
    }
    catch (e) {
        return false;
    }
};
export var getDeepLinkTargetUrl = function (url) {
    var _a;
    if (!isInternalUrl(url)) {
        return null;
    }
    try {
        var parsedUrl = new URL(url, DeepLinkBaseUrl);
        var query = getQueryFromUrl(parsedUrl);
        if (parsedUrl.searchParams.get(DeepLinkQueryKey) === DeepLinkQueryValue) {
            return ((_a = getProjectPath(url)) === null || _a === void 0 ? void 0 : _a.targetUrl) || null;
        }
        var projectDeepLink = getAppsFlyerProjectDeepLink(query);
        if (!projectDeepLink) {
            return null;
        }
        if (projectDeepLink.targetUrl) {
            return projectDeepLink.targetUrl;
        }
        var targetCompanyId = projectDeepLink.companyId;
        if (!isIdentifier(projectDeepLink.projectId) || !isIdentifier(targetCompanyId)) {
            return null;
        }
        return "/companies/" + targetCompanyId + "/projects/" + projectDeepLink.projectId + "?" + DeepLinkQueryKey + "=" + DeepLinkQueryValue;
    }
    catch (e) {
        return null;
    }
};
export var savePendingDeepLink = function (targetUrl) {
    var storage = getSessionStorage();
    if (!storage || !isDeepLinkUrl(targetUrl)) {
        return;
    }
    // 新しく受信したリンクを以前のログイン要求より優先する
    storage.removeItem(LocalStorageKeys.RedirectUrl);
    var pendingDeepLink = {
        targetUrl: targetUrl,
        createdAt: Date.now()
    };
    storage.setItem(PendingDeepLinkStorageKey, JSON.stringify(pendingDeepLink));
};
export var getPendingDeepLink = function (now) {
    if (now === void 0) { now = Date.now(); }
    var storage = getSessionStorage();
    if (!storage) {
        return null;
    }
    var value = storage.getItem(PendingDeepLinkStorageKey);
    if (!value) {
        return null;
    }
    try {
        var pendingDeepLink = JSON.parse(value);
        var isExpired = typeof pendingDeepLink.createdAt !== 'number' ||
            pendingDeepLink.createdAt > now ||
            now - pendingDeepLink.createdAt > PendingDeepLinkTtl;
        if (!isInternalUrl(pendingDeepLink.targetUrl) ||
            !isDeepLinkUrl(pendingDeepLink.targetUrl) ||
            isExpired) {
            storage.removeItem(PendingDeepLinkStorageKey);
            return null;
        }
        return pendingDeepLink.targetUrl;
    }
    catch (e) {
        storage.removeItem(PendingDeepLinkStorageKey);
        return null;
    }
};
export var consumePendingDeepLink = function (now) {
    var _a;
    if (now === void 0) { now = Date.now(); }
    var targetUrl = getPendingDeepLink(now);
    if (targetUrl) {
        (_a = getSessionStorage()) === null || _a === void 0 ? void 0 : _a.removeItem(PendingDeepLinkStorageKey);
    }
    return targetUrl;
};
export var discardPendingDeepLink = function () {
    var _a;
    (_a = getSessionStorage()) === null || _a === void 0 ? void 0 : _a.removeItem(PendingDeepLinkStorageKey);
};
